var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletedSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.25C7.40625 1.25 1.25 7.40594 1.25 15C1.25 22.5941 7.40625 28.75 15 28.75C22.5938 28.75 28.75 22.5941 28.75 15C28.75 7.40594 22.5938 1.25 15 1.25ZM15 26.25C8.78687 26.25 3.75 21.2131 3.75 15C3.75 8.78687 8.78687 3.75 15 3.75C21.2131 3.75 26.25 8.78687 26.25 15C26.25 21.2131 21.2131 26.25 15 26.25Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0889 11.6156C19.6008 11.1278 18.8092 11.1278 18.3211 11.6156L13.9017 16.0353L12.1339 14.2675C11.6458 13.7794 10.8545 13.7794 10.3661 14.2675C9.87797 14.7556 9.87797 15.5472 10.3661 16.0356L13.0173 18.6866C13.5055 19.1747 14.2973 19.1747 14.7855 18.6866L20.0886 13.3834C20.577 12.8953 20.5777 12.1041 20.0889 11.6156Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedSvg);
export default __webpack_public_path__ + "static/media/completedSvg.3c4fc7de86da348f6a62873a434127ee.svg";
export { ForwardRef as ReactComponent };